import React from 'react'
import Svg, { Path } from 'react-native-svg'

export default function Community(props) {
  return (
    <Svg width="22" height="16" viewBox="0 0 22 16" fill="none" {...props}>
      <Path
        fill={props.color || '#323232'}
        d="M15.67 9.13C17.04 10.06 18 11.32 18 13V16H22V13C22 10.82 18.43 9.53 15.67 9.13Z"
      />
      <Path
        fill={props.color || '#323232'}
        d="M14 8C16.21 8 18 6.21 18 4C18 1.79 16.21 0 14 0C13.53 0 13.09 0.0999998 12.67 0.24C13.5 1.27 14 2.58 14 4C14 5.42 13.5 6.73 12.67 7.76C13.09 7.9 13.53 8 14 8Z"
      />
      <Path
        fill={props.color || '#323232'}
        d="M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 2C9.1 2 10 2.9 10 4C10 5.1 9.1 6 8 6C6.9 6 6 5.1 6 4C6 2.9 6.9 2 8 2Z"
      />
      <Path
        fill={props.color || '#323232'}
        d="M8 9C5.33 9 0 10.34 0 13V16H16V13C16 10.34 10.67 9 8 9ZM14 14H2V13.01C2.2 12.29 5.3 11 8 11C10.7 11 13.8 12.29 14 13V14Z"
      />
    </Svg>
  )
}

Community.propTypes = Svg.propTypes
